import React from 'react';
import { Form, Input } from 'antd';
import { productProperties } from 'config/language';
import ChannelsSelectField from './ChannelsSelect';

const { TextArea } = Input;

const Extras = () => (
  <div className="columns-container">
    <div className="column">
      <Form.Item
        name="story"
        label={productProperties.story.labels.field}
        labelCol={{ span: 24 }}
      >
        <TextArea
          autoSize={{ minRows: 4 }}
        />
      </Form.Item>
    </div>
    <div className="column">
      <ChannelsSelectField country="nz" fieldName="channelsNz" label="Channels - New Zealand" />
      <ChannelsSelectField country="au" fieldName="channelsAu" label="Channels - Australia" />
      <Form.Item
        name="accolades"
        label={productProperties.accolades.labels.field}
        labelCol={{ span: 24 }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="eventsAndMarketing"
        label={productProperties.eventsAndMarketing.labels.field}
        labelCol={{ span: 24 }}
      >
        <TextArea
          autoSize={{ minRows: 4 }}
        />
      </Form.Item>
      <Form.Item
        name="other"
        label={productProperties.other.labels.field}
        labelCol={{ span: 24 }}
      >
        <TextArea
          autoSize={{ minRows: 4 }}
        />
      </Form.Item>
    </div>
    <Form.Item name="brewSize" style={{ display: 'none' }}>
      <Input />
    </Form.Item>
  </div>
);

export default Extras;
